/*
 * @Description: 
 */
/*
 * @Description: 
 */

import axios from "axios";
import iView from 'iview'
let tempAxios = 0;


const Axios = axios.create({
	headers: {
		// 'Content-Type': 'application/json;charset:utf-8;'
	},
	// timeout: 5000                  // 超时
});

Axios.interceptors.request.use(
	(config) => {
		config.headers["descode"] = localStorage.descode //localStorage.jeesiteToken;
		tempAxios = 0;
		if (config.loadingHide != false) {
			tempAxios++;

		}
		return config;
	},
	(error) => {
		console.log("发送失败");
		return Promise.reject(error);
	}
);

Axios.interceptors.response.use(
	(response) => {
		if (response.config.loadingHide != false) {
		}

		if(response.data.code == 10000) { 
			localStorage.setItem('userinfo',null)
			location.reload()
		}
		return response.data;
	},
	(error) => {
		// alert('用户session过期，请重新登录！')
		throw Promise.reject(error);
	}
);

export default Axios;
